// src/components/Experiment/SampleTable.js
import React, { useState } from 'react';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';

const SampleTable = ({
  samples,
  onUpdateSample,
  onDeleteSample,
  onHighlightSample,
  highlightedSample
}) => {
  const [editingSample, setEditingSample] = useState(null);
  const [editValues, setEditValues] = useState({});

  const handleEditStart = (sample) => {
    setEditingSample(sample.id);
    setEditValues({
      name: sample.name,
      coordinates: sample.coordinates
    });
  };

  const handleEditSave = (sampleId) => {
    onUpdateSample(sampleId, editValues);
    setEditingSample(null);
    setEditValues({});
  };

  const handleEditCancel = () => {
    setEditingSample(null);
    setEditValues({});
  };

  if (samples.length === 0) {
    return (
      <div className="text-center text-muted py-4">
        <i className="bi bi-grid-3x3 display-4"></i>
        <p className="mt-2">No samples defined yet</p>
        <small>Select cells on the grid to create samples</small>
      </div>
    );
  }

  return (
    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
      <Table size="sm" className="mb-0">
        <thead className="table-light sticky-top">
          <tr>
            <th style={{ width: '40%' }}>Coordinates</th>
            <th style={{ width: '45%' }}>Sample Name</th>
            <th style={{ width: '15%' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {samples.map((sample) => (
            <tr
              key={sample.id}
              className={highlightedSample === sample.id ? 'table-warning' : ''}
              onMouseEnter={() => onHighlightSample(sample.id)}
              onMouseLeave={() => onHighlightSample(null)}
            >
              <td>
                {editingSample === sample.id ? (
                  <Form.Control
                    size="sm"
                    type="text"
                    value={editValues.coordinates || ''}
                    onChange={(e) => setEditValues({
                      ...editValues,
                      coordinates: e.target.value
                    })}
                    placeholder="A1:B3, C1"
                  />
                ) : (
                  <code className="small">{sample.coordinates}</code>
                )}
              </td>
              <td>
                {editingSample === sample.id ? (
                  <Form.Control
                    size="sm"
                    type="text"
                    value={editValues.name || ''}
                    onChange={(e) => setEditValues({
                      ...editValues,
                      name: e.target.value
                    })}
                    placeholder="Sample name"
                  />
                ) : (
                  <span>{sample.name}</span>
                )}
              </td>
              <td>
                {editingSample === sample.id ? (
                  <div className="d-flex gap-1">
                    <Button
                      size="sm"
                      variant="success"
                      onClick={() => handleEditSave(sample.id)}
                      disabled={!editValues.name?.trim()}
                    >
                      <i className="bi bi-check"></i>
                    </Button>
                    <Button
                      size="sm"
                      variant="secondary"
                      onClick={handleEditCancel}
                    >
                      <i className="bi bi-x"></i>
                    </Button>
                  </div>
                ) : (
                  <div className="d-flex gap-1">
                    <Button
                      size="sm"
                      variant="outline-primary"
                      onClick={() => handleEditStart(sample)}
                    >
                      <i className="bi bi-pencil"></i>
                    </Button>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => onDeleteSample(sample.id)}
                    >
                      <i className="bi bi-trash"></i>
                    </Button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SampleTable;